import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import CircularLoader from '../../components/CircularLoader';
import Cookies from 'js-cookie';

const SentForSign = () => {
const [series, setSeries] = useState([]);
const [labels, setLabels] = useState([]);
const [isLoading, setIsLoading] = useState(false);

  const chartOptions = {
    chart: {
      type: 'donut',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
    },
    labels,
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(1)}%`,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val.toFixed(0)}`,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '13px',
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    colors: ['#626DA1', '#94BBD4', '#E1E1E1', '#FFBD88', '#FFE5E5'],
    
  };

  useEffect(() => {
    const fetchChartData = async () => {
      setIsLoading(true);
      try {
          const token = axios.defaults.headers.common.Authorization;
        const url = `${process.env.REACT_APP_BASE_URL}admin/consent_bundle_status_breakdown`;

        const response = await axios.get(url, {
             headers: {
                       Authorization: `${token}`,
                     },
        });

        const responseData = response.data;
        const fetchedLabels = Object.keys(responseData);
        const fetchedSeries = Object.values(responseData);

        setLabels(fetchedLabels);
        setSeries(fetchedSeries);
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChartData();
  }, []);

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  };

  const allValuesAreZero = series.every((val) => val === 0);

  return (
    <div id="homepage-ConsentsCompletedChart" style={isLoading ? containerStyle : {}}>
      {isLoading ? (
        <div data-testid="loader">
          <CircularLoader />
        </div>
      ) : allValuesAreZero ? (
        <div style={containerStyle}>No data matches these filters.</div>
      ) : (
        <ReactApexChart
          data-testid="chart"
          options={chartOptions}
          series={series}
          type="donut"
          width={400}
        />
      )}
    </div>
  );
};

export default SentForSign;
